import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceProjectSettingsRedirectRoute: InvariantJiraRoute = {
	name: 'customer-service-project-settings',
	path: '/jira/customer-service-management/projects/:projectKey/settings',
	exact: true,
};
